import React from 'react'
import { isOpenReportsTransferModal } from 'Pages/Admin/ReportsHandler/@signals'
import { IconSeeker } from '@ui-seeker/core'
import { AppModal } from '@components'
import { dsColorNew } from '@palette'
import { Grid, Typography, Box } from '@mui/material'
import DestinationUser from 'Pages/Admin/ReportsHandler/Modal/UserDestination'


export default function ReportsHandlerModal() {


	if(!isOpenReportsTransferModal.value?.length) return null


	return <AppModal
		icon="share-from-square"
		subtitle={`${isOpenReportsTransferModal.value.length} report${isOpenReportsTransferModal.value.length === 1 ? '' : 's'} selected`}
		isOpen={!!isOpenReportsTransferModal.value?.length}
		controller={() => isOpenReportsTransferModal.value = []}
		title='Select the user that will receive the reports'
		hideActions
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Typography sx={{ fontSize: 11, fontWeight: 600, color: dsColorNew.textSubtle, textTransform: 'uppercase', letterSpacing: 0.6, mb: 1 }}>Selected reports</Typography>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1, flexWrap: 'wrap' }} >
					{isOpenReportsTransferModal.value.map(({ name, numSearches }) => <Box
						key={name}
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
							backgroundColor: dsColorNew.tableRowAlt,
							border: `1px solid ${dsColorNew.grayBorder}`,
							borderRadius: '8px',
							px: 1,
							py: .75,
							gap: 1,
							width: '30%'
						}}
					>
						<IconSeeker icon='circle' sx={{ fontSize: 8, color: numSearches > 1000 ? dsColorNew.dangerRed : dsColorNew.successBar }} />
						<Typography variant='caption'>{name}</Typography>
					</Box>)}
				</Box>
			</Grid>
			<Grid item xs={12}>
				<DestinationUser />
			</Grid>
		</Grid>
	</AppModal>
}